import React from 'react';
import '../less/pbpEntityNew.less';
import hero_img from '../img/pbp-entity/hero_img.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import { Preloader } from 'MWComponents';
import MoreSliderBlock from '../../../auxiliary-components/shared/MoreSliderBlock';
import { buildPartnersSlides } from '../../Credit/helper/buildPartnerSlides';
import partners_arrow from '../img/pbp-entity/partners_arrow.svg';
import { ReactSVG } from 'react-svg';
import { buildPartnersGrouped } from '../../Credit/helper/buildPartnersGrouped';
import hero_data from '../enums/pbp-entity/hero_data.json';
import PbpEntityOrder from "../components/PbpEntityOrder";
import additionalCards from '../enums/pbp-entity/additional_items.json';
import tools_arrow from '../img/pbp-entity/tools_arrow.svg';
import tools_img_1 from '../img/pbp-entity/tools_img_1.png';
import tools_img_2 from '../img/pbp-entity/tools_img_2.png';
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import { brend_thing_pbp, pbp_api_docs } from '../../../services/urls/urls';
import DOMPurify from 'utils/sanitize';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { canUseDOM } from './../../../helpers/canUseDOM';

export default function template() {
    const page = 'pbp-entity-new';
    const model = this.getModel();

    const handlersMap = {
      toggleHeroModal: this.toggleModal,
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    const partnersWidget = this.widgetsHelper.getWidget_2.call(this, 'partners');

    const partnersSlides = buildPartnersSlides(partnersWidget, this.state.environment);

    const partnersGrouped = buildPartnersGrouped(this.state.partnersData);

    const partnersTabs = partnersGrouped.map(category => ({
      tab: `partner-${category.category_id}`,
      title: category.title
    }));

    return (
      <div className="pbp-entity-new">
        <Hero
          data={heroData}
          img={hero_img}
          page={page}
        />
        <div className={`content${(this.state.faqTab || this.state.partnersTab) ? ' hidden' : ''}`}>
            {partnersSlides && partnersSlides.length > 0 ? (
              <MoreSliderBlock
                swiperRef={this.sliderRefPartners}
                items={partnersSlides}
                className={"partners-slider"}
                title={'PBP_ENTITY_NEW_PARTNERS_TITLE'}
                subtitle={'PBP_ENTITY_NEW_PARTNERS_SUBTITLE'}
                groupSize={8}
                slidesPerView={1}
                spaceBetween={8}
                controlsBelowOnMobile={true}
                btnText={'PBP_ENTITY_NEW_PARTNERS_BTN_TEXT_1'}
                btnId={`${page} partners-btn`}
                btnLink={"/credit/pbp"}
                renderSlide={(item, index) => {
                  if (item.type === 'all-partners') {
                    return (
                      <button
                        key={index}
                        className="item-more-slider__all-partners"
                        href={item.file_path}
                        onClick={this.toggleAllPartnersTab}
                        target="_blank"
                        id={`${page} all-partners-btn`}
                      >
                        <div className="item-more-slider__text">{this.l10n('PBP_ENTITY_NEW_PARTNERS_BTN_TEXT_2')}</div>
                        <ReactSVG
                          src={partners_arrow}
                          className="item-more-slider__arrow"
                        />
                      </button>
                    );
                  }

                  return (
                    <a
                      key={index}
                      className="item-more-slider__link"
                      href={item.file_path}
                      target="_blank"
                    >
                      <img className="item-more-slider__image" src={item.img_desktop} alt={DOMPurify.sanitize(item.title, {
                        ALLOWED_TAGS: [],
                        ALLOWED_ATTR: []
                      })}/>
                      <div className="item-more-slider__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title)}}></div>
                    </a>
                  );
                }}
              />
              ) : (canUseDOM ? <Preloader /> : null)
            }
            <div className="steps">
              <div className="container">
                <div className="steps__body">
                  <div className="steps__item">{this.l10n('PBP_ENTITY_NEW_STEPS_TEXT_01')}</div>
                  <div className="steps__item">{this.l10n('PBP_ENTITY_NEW_STEPS_TEXT_02')}</div>
                  <div className="steps__item">{this.l10n('PBP_ENTITY_NEW_STEPS_TEXT_03')}</div>
                  <div className="steps__item">{this.l10n('PBP_ENTITY_NEW_STEPS_TEXT_04')}</div>
                  <div className="steps__item">{this.l10n('PBP_ENTITY_NEW_STEPS_TEXT_05')}</div>
                </div>
              </div>
            </div>
            <div className="suitable-for">
              <div className="container">
                <h2 className="suitable-for__title">{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_TITLE')}</h2>
                <div className="suitable-for__body">
                  <div className="suitable-for__item item-suitable-for">
                    <h3 className="item-suitable-for__title">{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_01_TITLE')}</h3>
                    <div className="item-suitable-for__text">
                      <ul>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_01_TEXT_01')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_01_TEXT_02')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_01_TEXT_03')}</li>
                      </ul>
                      <p>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_01_TEXT_04')}</p>
                    </div>
                  </div>
                  <div className="suitable-for__item item-suitable-for">
                    <h3 className="item-suitable-for__title">{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TITLE')}</h3>
                    <div className="item-suitable-for__text">
                      <ul>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_01')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_02')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_03')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_04')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_05')}</li>
                        <li>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_02_TEXT_06')}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="suitable-for__item item-suitable-for">
                    <h3 className="item-suitable-for__title">{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TITLE')}</h3>
                    <div className="item-suitable-for__text">
                      <ul>
                        <li><b>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TEXT_01')}</b></li>
                      </ul>
                      <p>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TEXT_02')}</p>
                      <ul>
                        <li><b>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TEXT_03')}</b></li>
                      </ul>
                      <p>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TEXT_04')}</p>
                      <ul>
                        <li><b>{this.l10n('PBP_ENTITY_NEW_SUITABLE_FOR_ITEMS_03_TEXT_05')}</b></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <AdditionalProduct
              items={additionalCards}
              title={'PBP_ENTITY_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <div className="tools">
              <div className="container">
                <h2 className="tools__title">{this.l10n('PBP_ENTITY_NEW_TOOLS_TITLE')}</h2>
                <div className="tools__body">
                  <a href={brend_thing_pbp} target='_blank' className="tools__item tools__item_left">
                    <div className="tools__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('PBP_ENTITY_NEW_TOOLS_TEXT_01'))}}></div>
                    <ReactSVG
                      src={tools_arrow}
                      className="tools__arrow"
                    />
                    <img src={tools_img_1} alt="tools img" className="tools__img"/>
                  </a>
                  <a href={pbp_api_docs} target='_blank' className="tools__item tools__item_right">
                    <div className="tools__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('PBP_ENTITY_NEW_TOOLS_TEXT_02'))}}></div>
                    <ReactSVG
                      src={tools_arrow}
                      className="tools__arrow"
                    />
                    <img src={tools_img_2} alt="tools img" className="tools__img"/>
                  </a>
                </div>
              </div>
            </div>
            {model &&  model.fields && model.fields.max ? (
              <CalculatorNew model={model} type="pbp_entity" {...this.props}/>
            ) : (canUseDOM ? <Preloader /> : null)}
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'PBP_ENTITY_NEW_QUESTIONS_ADMIN_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
        </div>
        <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('PBP_ENTITY_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('PBP_ENTITY_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        </div>
        <div className={`content${!this.state.partnersTab ? ' hidden' : ''}`}>
          {this.state.partnersData && this.state.partnersData.length > 0 ? (
            <Tabs
              tabs={partnersTabs}
              toggle={this.togglePartnerTab}
              tab={this.state.partnerTab}
              title={'PBP_ENTITY_NEW_ALL_PARTNERS_TITLE'}
              showArrows
            >
              {partnersGrouped.map(category => (
                <div key={category.category_id} className="partners">
                  <div className="container">
                    <div className="partners__items">
                      {category.items.map(partner => (
                        <a
                          key={partner.id}
                          href={partner.site}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="partners__item item-partners"
                        >
                          <div className="item-partners__image">
                            <img
                              src={partner.logo_url}
                              alt={DOMPurify.sanitize(partner.name, {
                                ALLOWED_TAGS: [],
                                ALLOWED_ATTR: []
                              })}
                            />
                          </div>
                          <div className="item-partners__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(partner.name)}}></div>
                        </a>
                      ))}
                    </div>
                    <button 
                      className="partners__btn" 
                      onClick={this.toggleAllPartnersTab}
                    >
                      {this.l10n('PBP_ENTITY_NEW_ALL_PARTNERS_BTN_TEXT')}
                    </button>
                  </div>
                </div>
              ))}
            </Tabs>
          ) :  (canUseDOM ? <Preloader /> : null)}
        </div>
        {this.state.showModal ? <PbpEntityOrder attribute={'pbp-entity'} utmParams={this.state.utmParams}  closeModal={this.toggleModal} /> : ''}
      </div>
    );
}
